import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=4fc4970f"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=4fc4970f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports